// eslint-disable-next-line no-undef
const postfix = `_${g_key}`;

export default ({
  postfix,
  types: {},
  key(key) {
    return `${key}${this.postfix}`;
  },
  set(key, value) {
    let output = 0;
    switch (this.types[key].type) {
      case Boolean: output = 1 * value; break;
      case Object:
      case Array:
        output = JSON.stringify(value); break;
      default: output = value; break;
    }
    localStorage.setItem(this.key(key), output);
  },
  get(key) {
    const val = localStorage.getItem(this.key(key));
    if (val === null) return this.types[key].def;
    switch (this.types[key].type) {
      case Boolean: return !!(1 * val);
      case Array:
        try {
          return JSON.parse(val);
        } catch (e) {
          return [];
        }
      case Object:
        try {
          return JSON.parse(val);
        } catch (e) {
          return {};
        }
      default: return val;
    }
  },
  clear(key) {
    localStorage.removeItem(this.key(key));
  },
  init(key, type, def) {
    this.types[key] = { type, def };
    return this.get(key);
  },
});
